<template>
  <va-create-layout>
    <testimonies-form :title="title" :item="item"></testimonies-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
